export default __webpack_public_path__ + "static/business-4b88c1250b18c250e6f716aff0ceddc9.png";